import BigNumber from 'bignumber.js'
import { useEffect, useState } from 'react'
import { useWeb3Context } from './useWeb3Context';
import { universeContract } from '../utils/contracts';

function useMaxMint(refresh: boolean = false) {
  const { provider, address } = useWeb3Context();
  const [maxMintPerTransaction, setMaxMintPerTransaction] = useState(new BigNumber(0))
  const [mintAmountLeft, setMintAmountLeft] = useState(0)

  useEffect(() => {
    const getMaxMint = async () => {
      const maxPerTx = await universeContract(provider).maxPerTx();
      setMaxMintPerTransaction(maxPerTx)

      if (address) {
        const numberMinted = await universeContract(provider).numberMinted(address);
        const maxMintTotalPerAddress = await universeContract(provider).maxMintTotalPerAddress();
        setMintAmountLeft(new BigNumber(maxMintTotalPerAddress.toString()).minus(numberMinted.toString()).toNumber());
      }
    }

    getMaxMint();
  }, [address, provider, refresh])

  useEffect(() => {
    return () => {
      setMaxMintPerTransaction(new BigNumber(0));
    };
  }, []);

  return {
    maxMintPerTransaction,
    mintAmountLeft
  };
}

export default useMaxMint;